import { array, intersect, literal, nullable, partial, struct, union } from 'io-ts/Decoder';

import { Id as ClientTypeId } from '../client/client-type/Id';
import { Id as ClientId } from '../client/Id';
import { CountryCode } from '../country/CountryCode';
import { Id as CustomerId } from '../customer/Id';
import { Id as FranchiseId } from '../franchise/Id';
import { Id as OrganizationId } from '../organization/Id';
import { Id as PrincipalId } from '../principal/Id';

export const ScopeFilter = union(
	struct({
		type: literal('system'),
	}),
	intersect(
		struct({
			type: literal('country'),
			countryCodes: array(CountryCode),
		})
	)(
		partial({
			clientType: ClientTypeId,
		})
	),
	struct({
		type: literal('franchise'),
		franchiseIds: array(FranchiseId),
	}),
	struct({
		type: literal('organization'),
		organizationIds: array(OrganizationId),
	}),
	struct({
		type: literal('principal'),
		principalIds: array(PrincipalId),
	}),
	struct({
		type: literal('customer'),
		customerIds: array(CustomerId),
	}),
	intersect(
		struct({
			type: literal('client'),
			clientIds: array(ClientId),
		})
	)(
		partial({
			primaryClientId: nullable(ClientId),
		})
	)
);
